module.exports = __webpack_public_path__ + "static/media/twitter.3772b867.svg";